export default function formatNumbersStandard(number) {
  if (isNaN(number)) return 0;

  // Redondear al alza si hay decimales
  const roundedNumber = Math.ceil(number);

  const formatter = Intl.NumberFormat('es', { notation: 'standard' });
  return formatter.format(roundedNumber);
}
